module.exports = __webpack_public_path__ + "static/img/water5.6a9e981d.webp";